import { render, staticRenderFns } from "./PlatformFormModal.vue?vue&type=template&id=31995431&scoped=true"
import script from "./PlatformFormModal.vue?vue&type=script&lang=js"
export * from "./PlatformFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31995431",
  null
  
)

export default component.exports